
import { GetPermissionTreeData } from "../../pages/securityPermission/GenarateTreeData";
import { signOut } from "../../utils/AuthenticationLibrary";
import BaseDomainService from "./baseDomainServices";
 

const formField = {
  roleId: "",
  moduleId: "",
  submoduleId : ""
}

export default class modulePermissionServices extends BaseDomainService {

  savePermission = this.apiService.securityPermissionServices.addSecurityPermissions;
  getModules = this.apiService.modulePermissionServices.getAllModules;
  getSubModules = this.apiService.modulePermissionServices.getAllSubModulesByModuleId;
  getRoles = this.apiService.securityPermissionServices.getRoleListByClientIdAndClientSecret;
  showSecurityPermission = this.apiService.modulePermissionServices.getAllSubModuleSecurityPermissionsByRoleIdAndSubModuleSecurityKeyParentId;
  formFields = [
    {
      inputType: "select",
      tittle: "Select Roles",
      placeholder: "Select Dropdown",
      fieldName: "roleId",
      options: [],
      optionFieldName: "roleName",
      subRequest: "1",
      className: '',
      validation: [{ type: "require" }]
    },
    {
      inputType: "select",
      tittle: "Select Module",
      placeholder: "Select Dropdown",
      fieldName: "moduleId",
      options: [],
      optionFieldName: "securityKeyName",
      subRequest: "1",
      className: '',
      validation: [{ type: "require" }]
    },
    {
      inputType: "select",
      tittle: "Select Sub Module",
      placeholder: "Select Dropdown",
      fieldName: "submoduleId",
      options: [],
      optionFieldName: "securityKeyName",
      subRequest: "1",
      className: '',
      validation: [{ type: "require" }]
    }
  ]
  dataItem;

  onGetRoles = () => {
    this.apiService.onAPICall("getRoles", this.getRoles, null, this.onAPIResponse, this.onUpdateState);
  };

  onGetModules = () => {
    this.apiService.onAPICall("getModules", this.getModules, null, this.onAPIResponse, this.onUpdateState);
  };
  onGetSubModules =(moduleId) =>{
    this.apiService.onAPICall("getsubModules", this.getSubModules, moduleId, this.onAPIResponse, this.onUpdateState);
  }
  onShowSecurity = (request) => {
    this.apiService.onAPICall("showSecurity", this.showSecurityPermission, request, this.onAPIResponse, this.onUpdateState);
  };
  onSavePermission = (request) => {
    this.apiService.onAPICall("savePermission", this.savePermission, request, this.onAPIResponse, this.onUpdateState);

  }
  constructor() {
    super();
    this.dataItem = { ...formField, CreatedBy: this.authUser ? this.authUser.adminUserId : null };
  }


  onAPIResponse = (key, isSuccess, responseData) => {
    this.onUpdateState({ setIsLoad: false });
    if (!isSuccess) {
      this.onUpdateState({ setIsLoad: false });
      return;
    }
    switch (key) {
      case "savePermission":
        this.apiService.serviceManager.swalServices.Confirm(
          "Security Permissions Updated!", "You will be logged out! Please Log In again",
          "LogOut", "No", false)
          .then(async (confirm) => {
            if (confirm) {
              signOut()
            }
          });
        this.onUpdateState({ "setIsLoad": false });
        break;
      case "getRoles":
        let itemRoleList = responseData;
        if (itemRoleList !== null) {
          const roles = itemRoleList.map(item => ({
            id: item.roleId,
            name: item.roleName,
          }));
          this.onUpdateState({
            setRoleList: roles,
            setIsLoad: false,
          });
        }
        break;
      case "getModules":
        let itemList = responseData;
        if (itemList !== null) {
          const modules = itemList.map(item => ({
            id: item.securityKeyId,
            name: item.securityKeyName,
            isSubModuleExist:item.isSubModuleExist,
          }));
          this.onUpdateState({
            setModuleList: modules,
            setIsLoad: false,
          });
        }
        break;
        case "getsubModules":
        let itemsubmodilelist = responseData;
        if (  itemsubmodilelist !== null) {
          const modules = itemsubmodilelist.map(item => ({
            id: item.securityKeyId,
            name: item.securityKeyName,
          }));
          this.onUpdateState({
            setSubModuleList: modules,
            setIsLoad: false,
          });
        }
        break;
      case "showSecurity":
        let itemData = responseData;
        let data = GetPermissionTreeData(itemData);
        this.onUpdateState({
          setPermissionTreeData: data,
          permissionItem: data,
          setIsLoad: false,
        });
        break;
        default:
          break;
    }
  };
}

